interface Props {
  onLegalClick: () => void;
  onPrivacyClick?: () => void;
  onTermsClick?: () => void;
  onSubprocessorsClick?: () => void;
}

export default function Footer({ onLegalClick, onPrivacyClick, onTermsClick, onSubprocessorsClick }: Props) {
  return (
    <footer className="hidden shrink-0 flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-3.5 text-xs text-slate-400 md:flex">
      <span>Outil d'aide &agrave; la d&eacute;cision &mdash; non-opposable.</span>
      <button
        onClick={onLegalClick}
        className="underline hover:text-slate-600 transition-colors"
      >
        Mentions l&eacute;gales
      </button>
      {onPrivacyClick && (
        <button
          onClick={onPrivacyClick}
          className="underline hover:text-slate-600 transition-colors"
        >
          Confidentialit&eacute;
        </button>
      )}
      {onTermsClick && (
        <button
          onClick={onTermsClick}
          className="underline hover:text-slate-600 transition-colors"
        >
          CGU
        </button>
      )}
      {onSubprocessorsClick && (
        <button
          onClick={onSubprocessorsClick}
          className="underline hover:text-slate-600 transition-colors"
        >
          Sous-traitants
        </button>
      )}
    </footer>
  );
}
